import React, { createContext, useState, useEffect, useContext } from "react";

import { getStoredState, updateStoredState } from "../utils/localStorage";

const InstitutionContext = createContext();

export const InstitutionProvider = ({ children }) => {
  const stored = getStoredState() || {};

  const [institution, setInstitution] = useState(stored.institution || {});
  const [firstAccess, setFirstAccess] = useState(stored.firstAccess ?? false);

  useEffect(() => {
    try {
      updateStoredState({ institution, firstAccess });
    } catch (error) {
      console.error("Erro ao salvar estado:", error);      
    }
  }, [institution, firstAccess]);

  return (
    <InstitutionContext.Provider value={{ institution, setInstitution, firstAccess, setFirstAccess }}>
      {children}
    </InstitutionContext.Provider>
  );
};

export const useInstitution = () => useContext(InstitutionContext);
